export default __webpack_public_path__ + "static/media/hero2.05bc19f6.jpeg";